query getOrgDesignWorkspaceConfig($workspaceId: ID!) {
  workspace: getWorkspace(id: $workspaceId) {
    id
    name
    description
    config {
      insightsHierarchy
      defaultInsightsHierarchyView
      orgChartAttributePolicies
      orgChartAttributeLabels
    }
  }
}
